export const ACTIONS = {
  PERFORMANCE: {
    SET_FIELD: 'SET_FIELD',
    SET_FIELDS: 'SET_FIELDS',
    RESET: 'RESET',
  },
};
